import clsx from "clsx";
import { TABS } from "./hooks/useDataPair";

type Props = {
  tabActive: string;
  onChangeTab: (tab: string) => void;
};

export default function Tab({ tabActive, onChangeTab }: Props) {
  return (
    <div className="flex gap-x-3">
      {TABS.map((item) => {
        return (
          <button
            key={item.value}
            onClick={() => onChangeTab(item.value)}
            className={clsx("text-2xl text-[#4C4C4C] font-medium transition-all", {
              "!text-primary": item.value === tabActive,
            })}
          >
            {item.title}
          </button>
        );
      })}
    </div>
  );
}
